import { inject } from 'vue';

export const useModelExporter = () => {
    const modelExporter = inject('modelExporter', false);

    return modelExporter;
};
